import { flatMap } from 'lodash';
import { createSelector } from 'reselect';

export const getDuplicatePropertiesGroups = state => state.duplicates.properties;
export const getDuplicatePropertiesCount = state => state.duplicates.totalProperties;
export const getDuplicatePropertiesPage = state => state.duplicates.propertyPage;
export const getDuplicatePropertiesPageSize = state => state.duplicates.propertyPageSize;
export const isDuplicateViewActive = state => state.duplicates.viewActive;
export const isLoading = state => state.duplicates.isLoading;

export const getDuplicateProperties = createSelector(
  [getDuplicatePropertiesGroups],
  groups => flatMap(groups, group => group.properties)
);

export const getDuplicatePropertiesPageCount = createSelector(
  [getDuplicatePropertiesCount, getDuplicatePropertiesPageSize],
  (count, pageSize) => pageSize ? Math.ceil(count / pageSize) : 0
);
